import React from 'react'
import { useSelector } from 'react-redux'
import './ImpressionStatsCards.css'

const ImpressionStatsCards = () => {
  const { loading, data } = useSelector((state) => state.impressionStats)

  if (loading) {
    return <div className='loader'></div>
  }

  return (
    <div className='impression-stats-cards'>
      <div className='card'>
        <h3>Total Impressions</h3>
        <p>{data.totalImpressions || 0}</p>
      </div>
      <div className='card'>
        <h3>Unique Impressions</h3>
        <p>{data.uniqueImpressions || 0}</p>
      </div>
      <div className='card'>
        <h3>Total Reactions</h3>
        <p>{data.totalReactions || 0}</p>
      </div>
      <div className='card'>
        <h3>Contents Created</h3>
        <p>{data.totalContentsCreated || 0}</p>
      </div>
    </div>
  )
}

export default ImpressionStatsCards
